(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["msc-collection-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msc-vendor-contact')) {
    customElements.define('msc-vendor-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-status]');
        this.profileRequest = null;
        this.querySelector('details').addEventListener('toggle', () => {
          if (this.querySelector('details').open) this.getVendor().catch(() => {});
        });
        this.form.addEventListener('submit', event => this.send(event));
      }
      async getVendor() {
        if (this.vendorId) return this.vendorId;
        if (!this.profileRequest) {
          this.profileRequest = (async () => {
            const params = new URLSearchParams({shop: this.dataset.shop, vendor: this.dataset.vendor, meta: this.dataset.vendor, collectionId: this.dataset.collection});
            const response = await fetch('https://app.puppetvendors.com/webhooks/vendor/profiles?' + params, {signal: AbortSignal.timeout(15000)});
            if (!response.ok) throw new Error('Vendor unavailable');
            const data = await response.json();
            if (!data._id) throw new Error('Vendor unavailable');
            this.vendorId = data._id;
            this.dataset.connection = 'ready';
            return this.vendorId;
          })().catch(error => {
            this.profileRequest = null;
            this.dataset.connection = 'unavailable';
            throw error;
          });
        }
        return this.profileRequest;
      }
      async send(event) {
        event.preventDefault();
        if (this.sending || !this.form.reportValidity()) return;
        this.sending = true;
        const button = this.form.querySelector('button');
        button.disabled = true;
        this.status.textContent = this.dataset.sending;
        try {
          const vendorId = await this.getVendor();
          const values = new FormData(this.form);
          const content = 'Name: ' + values.get('name') + ', Phone: ' + values.get('phone') + ', Message: ' + values.get('message') + ', Source: ' + location.origin + location.pathname;
          const response = await fetch('https://app.puppetvendors.com/webhooks/customer-message/' + encodeURIComponent(vendorId) + '?source=vendor_message', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email: values.get('email'), content})
          });
          if (!response.ok) throw new Error('Message failed');
          this.form.reset();
          this.querySelector('details').open = false;
          this.status.textContent = this.dataset.success;
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally {
          this.sending = false;
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
